import React, {useState} from 'react'
import {Button, message, Modal, Result} from "antd"
import {fetchDeleteBlackList} from "../../../api/blackList"
import {useBlackListContext} from "../store/useBlackListContext"

const BlackListDeleted = ({recordId,memberName}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const {getBlackList} = useBlackListContext()

    const deleteBlackList = async () => {
        setIsLoading(true)
        await fetchDeleteBlackList(recordId).then(res => {
            if (res.status) {
                message.success('解除成功')
                return
            }
            message.error(`解除失败：${res.detail}`)
        }).catch(err => {
            message.error(`解除失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
            setIsShow(false)
            getBlackList()
        })
    }

    const handleOnClick = () => {
        setIsShow(true)
    }

    const handleOnOk = async () => {
        setIsShow(false)
        await deleteBlackList()
    }

    return (
        <div>
            <Button onClick={handleOnClick} type={"primary"} danger>解除俱乐部黑名单</Button>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                onOk={handleOnOk}
                destroyOnClose
                confirmLoading={isLoading}
            >
                <Result
                    status="warning"
                    title={`确定要解除 ${memberName} 的俱乐部黑名单吗？`}
                />
            </Modal>
        </div>
    )
}

export default BlackListDeleted



// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/component/BlackListDeleted.js